import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { margin, padding } from 'polished';
import { baselineToRem } from '@scp/ui-shared/theme/utils';
var MARGIN_PROP_KEYS = ['margin', 'marginVertical', 'marginHorizontal', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
var PADDING_PROP_KEYS = ['padding', 'paddingVertical', 'paddingHorizontal', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom'];
var SPACING_KEYS = [].concat(MARGIN_PROP_KEYS, PADDING_PROP_KEYS);

var pickByPriority = function pickByPriority() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return values.find(function (v) {
    return !!v || v === 0;
  });
};

var setMargin = function setMargin(props) {
  var top = pickByPriority(props.marginTop, props.marginVertical, props.margin);
  var right = pickByPriority(props.marginRight, props.marginHorizontal, props.margin);
  var bottom = pickByPriority(props.marginBottom, props.marginVertical, props.margin);
  var left = pickByPriority(props.marginLeft, props.marginHorizontal, props.margin);
  return margin(baselineToRem(top !== null && top !== void 0 ? top : null), baselineToRem(right !== null && right !== void 0 ? right : null), baselineToRem(bottom !== null && bottom !== void 0 ? bottom : null), baselineToRem(left !== null && left !== void 0 ? left : null));
};

var setPadding = function setPadding(props) {
  var top = pickByPriority(props.paddingTop, props.paddingVertical, props.padding);
  var right = pickByPriority(props.paddingRight, props.paddingHorizontal, props.padding);
  var bottom = pickByPriority(props.paddingBottom, props.paddingVertical, props.padding);
  var left = pickByPriority(props.paddingLeft, props.paddingHorizontal, props.padding);
  return padding(baselineToRem(top !== null && top !== void 0 ? top : null), baselineToRem(right !== null && right !== void 0 ? right : null), baselineToRem(bottom !== null && bottom !== void 0 ? bottom : null), baselineToRem(left !== null && left !== void 0 ? left : null));
};
/**
 * Helper component for spacing.
 * It accepts MULTIPLIER of BASELINE value as props (not value in pixels).
 *
 * @example ./__docs__/Spacing.md
 */


export var Spacing = styled.div(_templateObject(), setMargin, setPadding);
/**
 * Helper to extract SpacingProps from full props object.
 * Useful example, when building components, that uses <Spacing /> inside:
 *
 * ```
 * import { Spacing, SpacingProps, pickSpacingProps } from '@scp/ui-shared/components/layout';
 *
 * export type MyComponentProps = SpacingProps & { title: string };
 *
 * const MyComponent = (props: MyComponentProps) => {
 *    return <Spacing {...pickSpacingProps(props)}>{props.title}</Spacing>
 * }
 *
 * // In this case, only `margin` and `paddingLeft` will travel to inner <Spacing /> component
 * // <MyComponent title="Test" margin={2} paddingLeft={1} />
 * ```
 */

export var pickSpacingProps = function pickSpacingProps(props) {
  var propKeys = Object.keys(props);
  return propKeys.reduce(function (agg, key) {
    if (SPACING_KEYS.includes(key) || SPACING_KEYS.includes(key)) {
      agg[key] = props[key];
    }

    return agg;
  }, {});
};